export enum PartyListSections {
  WALKINS = 'walkins',
  UPCOMING = 'upcoming',
  SEATED = 'seated',
  NO_SHOWS = 'noShows',
  CANCELLATIONS = 'cancellations',
  FINISHED = 'finished',
}
